<template>
  <div class="single-sats-wrapper">
    <div class="sats" @click="expandPanel">
      <div class="sats-info">
        <div class="star-count">
          <div class="time">
            <span>{{ date }}</span>
            <span>{{ hour }}</span>
          </div>
        </div>
        <div class="star-wrapper">
          <span class="star__rate" v-text="rating" />
          <svg
            class="star__svg"
            viewBox="0 0 406.125 406.125"
            style="enable-background:new 0 0 406.125 406.125;"
          >
            <path
              fill="#c69d4e"
              d="M260.133,155.967c-4.487,0-9.25-3.463-10.64-7.73L205.574,13.075c-1.39-4.268-3.633-4.268-5.023,0
  L156.64,148.237c-1.39,4.268-6.153,7.73-10.64,7.73H3.88c-4.487,0-5.186,2.138-1.553,4.78l114.971,83.521
  c3.633,2.642,5.454,8.242,4.064,12.51L77.452,391.932c-1.39,4.268,0.431,5.592,4.064,2.951l114.971-83.521
  c3.633-2.642,9.519-2.642,13.152,0l114.971,83.529c3.633,2.642,5.454,1.317,4.064-2.951l-43.911-135.154
  c-1.39-4.268,0.431-9.868,4.064-12.51l114.971-83.521c3.633-2.642,2.934-4.78-1.553-4.78H260.133V155.967z"
            />
          </svg>
        </div>
      </div>
      <div class="down-btn" v-show="accordionOpen" @click="expandPanel">
        <svg
          @click="expandPanel"
          viewBox="0 0 451.847 451.847"
          :class="{ open: accordionOpen }"
          :fill="darkMode ? '#777' : '#999'"
        >
          <path
            d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
		c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
		c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
          />
        </svg>
      </div>
      <div class="bottom-sep" :class="{ plain: accordionOpen }">
        <span />
      </div>
    </div>
    <div
      class="accordion-1"
      :class="{ open: accordionOpen, close: !accordionOpen }"
    >
      <div
        class="accordion-2"
        :class="{
          open: accordionOpen2,
          close: !accordionOpen2
        }"
      >
        <profile-button
          v-if="hasProfile"
          :group="group"
          :name="name"
          :img="img"
          :customer-id="customerId"
        />
        <div class="table">
          <i class="table__hr" />
          <div class="stat-row">
            <h5>مبلغ خرید</h5>
            <h6 class="rial" v-text="price?.toLocaleString()" />
          </div>
        </div>
        <div class="comment" v-if="desc">
          <p v-text="desc" />
          <!-- <button @click="$emit('reply')">پاسخ</button> -->
          <a :href="`https://wa.me/${waMobile}`">
            <span>پاسخ</span>
            <svg viewBox="-23 -21 682 682.66669">
              <path
                d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0"
                fill-rule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileButton from '@common/ProfileButton'
export default {
  name: 'SatisfactionSingle',
  emits: ['reply'],
  components: { ProfileButton },
  props: {
    rating: Number,
    date: {
      type: String
    },
    hour: {
      type: String
    },
    desc: String,
    price: [String, Number],
    planType: String,
    group: String,
    img: String,
    name: String,
    customerId: [String, Number],
    hasProfile: {
      type: Boolean,
      default: true
    },
    mobile: { type: String, default: '091xxxxxxxx' }
  },
  data() {
    return {
      darkMode: false,
      accordionOpen: false,
      accordionOpen2: false
    }
  },
  methods: {
    changeTheme(state) {
      this.darkMode = !state
    },
    expandPanel() {
      this.accordionOpen = !this.accordionOpen
      if (this.accordionOpen) {
        setTimeout(() => {
          const fixedNavHeight = 50
          const { bottom } = this.$el.getBoundingClientRect()
          const limit = window.innerHeight - fixedNavHeight - bottom
          if (limit < 0) {
            window.scrollBy({ top: -limit, behavior: 'smooth' })
          }
        }, 200)
      }
      this.accordionOpen2 = !this.accordionOpen2
    }
  },
  computed: {
    waMobile() {
      return '+98' + this.mobile.substr(1)
    }
  }
}
</script>

<style scoped lang="scss">
$border-color: rgba(#777, 0.12);

.single-sats-wrapper {
  padding: 0 0 0 0;
  margin: 0 0 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .sats {
    $left-color: #101010;
    $right-color: #222;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 90px;
    width: 100%;
    background: #fff;
    border-radius: 0;
    padding: 0 0;
    cursor: pointer;

    .sats-info {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 0 20px;
      h3 {
        position: relative;
        direction: ltr;
        text-align: left;
        top: 7px;
        margin: 0;
        font-size: 18px;
        color: #eee;
      }
      .star-count {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .time {
          padding-top: 10px;
          direction: ltr;
          font-size: 13px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          margin-top: 3px;
          color: #777;
          margin-right: 5px;
        }
      }
      .star-wrapper {
        overflow: hidden;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        direction: ltr;
        position: relative;
        bottom: 0;
        background-color: #101010;
        border-radius: 10px;
        padding: 5px 13px 12px;

        .star__rate {
          height: 32px;
          position: relative;
          margin: 0 5px 0 0;
          color: #eee;
          position: relative;
          top: 9px;
          font-size: 25px;
        }
        .star__svg {
          width: 26px;
          height: 26px;
        }
      }
    }
    .bottom-sep {
      height: 1px;
      padding: 0;
      margin: 0;
      position: relative;
      overflow: hidden;
      border-radius: 0;
      background: rgba(#000, 0.2);
      width: 100%;
      transition: background-color 0.3s ease;
      &.plain {
        border-radius: 0;
      }
      span {
        position: absolute;
        transition: all 0.3s ease;
        background-color: $border-color;
        height: 1px;
        width: 100%;
        margin: 0 auto;
        right: 0;
        left: 0;
        bottom: 0px;
      }
    }

    .down-btn {
      position: absolute;
      cursor: pointer;
      width: 45px;
      height: 45px;
      right: 0;
      left: 0;
      margin: 0 auto;
      bottom: -15px;
      border-radius: 50%;
      background-color: #fff;
      z-index: 1;
      transform: scaleX(1.5);
      // box-shadow: 0px 7px 6px -2px rgba(0, 0, 0, 0.2);
      transition: background-color 0.3s ease;
      &.dark {
        background-color: rgb(31, 31, 31);
      }

      svg {
        width: 100%;
        height: 100%;
        transition: all 0.3s ease;
        transform: scale(0.33, 0.5);
        &.open {
          transform: rotate(180deg) scale(0.33, 0.5);
        }
      }
    }
  }

  .accordion-1 {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    border-radius: 0;
    margin: 0 0 0;
    padding: 0;
    max-height: 0;
    &.open {
      max-height: 700px;
    }
    &.close {
      max-height: 0;
    }
    .accordion-2 {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      margin: 0 0 0;
      padding: 30px 20px;
      background-color: #ddd;
      max-height: 700px;
      &.open {
        opacity: 1;
      }
      &.close {
        opacity: 0;
      }
      .comment {
        width: 100%;
        margin: 20px 0 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        p {
          text-align: justify;
          color: #555;
          padding: 0 10px;
          margin-bottom: 15px;
        }
        button,
        a {
          background-color: rgba(#000, 0.4);
          border-radius: 15px;
          // border-radius: 100%;
          height: 60px;
          width: 100%;
          text-align: center;
          outline: none;
          color: #fff;
          box-shadow: 0 0 10px 1px rgba(#fff, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            fill: #fff;
            width: 26px;
            height: 26px;
            margin-right: 5px;
          }
        }
      }
      .table {
        margin: 0;
        width: 100%;
        background-color: #eee;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 0 0 15px 15px;
        border: none;
        .stat-row {
          padding: 0 20px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          h5 {
            color: #000;
            font-size: 14px;
            margin: 0;
          }
          h6 {
            font-size: 16px;
            margin-bottom: 0;
            padding-top: 2px;
            direction: ltr;
            text-align: left;
            position: relative;
            color: #000;
            &.minus::before {
              position: absolute;
              left: -12px;
              content: '-';
            }
            &.rial::after {
              position: absolute;
              content: 'R';
              // color: #fff;
              font-size: 10px;
              right: -10px;
              top: 3px;
            }
            &.percent::after {
              content: '%';
              color: #777;
              top: 0px;
              left: 3px;
              position: relative;
            }
          }
        }
        .table__hr {
          width: calc(100% - 20px);
          height: 1px;
          background-color: #ddd;
        }
      }
      .btns-wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10px 0 10px;
      }
    }
  }
}
</style>
